<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" :absolute="false" />

    <v-card>
      <v-card-text>
        <h3 class="mb-4">Nauja paslauga</h3>

        <v-row no-gutters class="ml-0">
          <v-col cols="12" md="12">
            <div class="dataContainer">
              <div class="paslaugaContainer">
                <v-row>
                  <v-col
                    v-for="(kortele, korteleIndex) in filterItemList"
                    :key="korteleIndex"
                    cols="12"
                    :md="kortele.col"
                    class="mb-3"
                  >
                    <v-card class="paslauga-card px-0 py-1" elevation="5">
                      <v-row no-gutters>
                        <v-col
                          v-for="(grupe, grupeIndex) in kortele.grupeList"
                          :key="grupeIndex"
                          cols="12"
                          :md="grupe.col"
                        >
                          <v-card-title class="paslauga-title"
                            >{{ grupe.pavadinimas
                            }}<span class="paslauga-tooltip"
                              ><el-tooltip
                                :tooltip="grupe.tooltip"
                                external
                                @activate="
                                  eventPayload =>
                                    showAprasymas(eventPayload, grupe.tootipTop)
                                "/></span
                          ></v-card-title>
                          <v-card-text>
                            <v-row no-gutters>
                              <v-col
                                v-for="paslauga in grupe.paslaugos"
                                :key="paslauga.key"
                                cols="12"
                                :md="paslauga.col"
                                class="mb-2"
                              >
                                <el-savitarna-icon
                                  class="paslauga-icon mr-2"
                                  :icon="paslauga.icon"
                                  :title="paslauga.title"
                                  :type="kortele.colorType"
                                  :loading="loading"
                                  @click.native="paslaugaAction(paslauga)"
                                  @mouseover2.native="
                                    showAprasymas(paslauga.tooltip)
                                  "
                                  @mouseout2.native="hideAprasymas()"
                                />
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
              <!-- </v-col>
      <v-col cols="12" md="3"> -->
              <div
                class="aprasymasContainer"
                :style="`padding-top: ${this.paslaugaAprasymasTop}px`"
              >
                <div class="paslauga-aprasymas">
                  <el-paslauga-aprasymas
                    :tooltip="paslaugaAprasymas"
                    @close="hideAprasymas"
                  />
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

        <modal-sutartis-rusis
          :key="sutartisRusisKey"
          v-model="showSutartisRusis"
          @confirmSutartisRusis="confirmSutartisRusis"
          @cancelSutartisRusis="cancelConfirm"
        />
        <modal-paslauga-confirm
          :title="confirmTitle"
          :text="confirmText"
          :item="confirmItem"
          :action="confirmAction"
          v-model="showConfirm"
          @confirmAddIkeitimas="addIkeitimas"
          @confirmAddTeikimas="addTeikimas"
          @cancelConfirm="cancelConfirm"
        />
        <modal-info
          :title="infoTitle"
          :text="infoText"
          :type="infoType"
          v-model="showInfo"
          @confirmSubmit="submitInfo"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from '../hipoteka/hipotekaMap'
import userRole from '../../mixins/userRole'
import ModalSutartisRusis from '../modals/ModalSutartisRusis'
import ModalPaslaugaConfirm from '../modals/ModalPaslaugaConfirm'
import ModalInfo from '../modals/ModalInfo'

export default {
  name: 'NaujaPaslauga',
  components: {
    ModalSutartisRusis,
    ModalPaslaugaConfirm,
    ModalInfo,
  },
  mixins: [userRole],
  data() {
    return {
      pageloading: true,
      loading: false,
      sutartisRusisRefresh: 0,
      showSutartisRusis: false,
      confirmTitle: null,
      confirmText: null,
      confirmItem: null,
      confirmAction: null,
      showConfirm: false,
      infoTitle: null,
      infoText: null,
      infoType: null,
      showInfo: false,
      paslaugaAprasymas: null,
      paslaugaAprasymasTop: '0px',
    }
  },
  computed: {
    ...mapGetters(['objektasID']),

    filterItemList() {
      return [
        {
          col: 4,
          colorType: 'hipoteka',
          grupeList: [
            {
              pavadinimas: 'Hipotekos pabaiga',
              tooltip: 'Aprašymas. Nauja paslauga. Hipotekos pabaiga',
              tootipTop: 10,
              paslaugos: [
                {
                  key: 'savitarna-hipoteka-pabaiga',
                  title: 'Išregistruoti hipoteką',
                  tooltip:
                    'Aprašymas. Nauja paslauga. Hipotekos pabaiga. Išregistruoti',
                  icon: 'mdi-clipboard-remove-outline',
                  col: 12,
                  action: this.redirectToList,
                  igaliotinisRole: ['EL_igaliojimas_pabaiga'],
                },
              ],
            },
            {
              pavadinimas: 'Įkeitimo pabaiga',
              tooltip: 'Aprašymas. Nauja paslauga. Įkeitimo pabaiga',
              tootipTop: 10,
              paslaugos: [
                {
                  key: 'savitarna-ikeitimas-pabaiga',
                  title: 'Išregistruoti įkeitimą',
                  tooltip:
                    'Aprašymas. Nauja paslauga. Įkeitimo pabaiga. Išregistruoti',
                  icon: 'mdi-clipboard-remove-outline',
                  col: 12,
                  action: this.redirectToList,
                  igaliotinisRole: ['EL_igaliojimas_pabaiga'],
                },
              ],
            },
          ],
        },
        {
          col: 4,
          colorType: 'hipoteka',
          grupeList: [
            {
              pavadinimas: 'Įkeitimo sudarymas',
              tooltip: 'Aprašymas. Nauja paslauga. Įkeitimo sudarymas',
              tootipTop: 10,
              paslaugos: [
                {
                  key: 'sutartinis-ikeitimas-sandoris',
                  title:
                    'Sudaryti sandorį informacinių technologijų priemonėmis',
                  tooltip:
                    'Aprašymas. Nauja paslauga. Įkeitimo sudarymas. Sandoris',
                  icon: 'mdi-briefcase-plus-outline',
                  col: 12,
                  action: this.ikeitimasNew,
                  igaliotinisRole: ['EL_igaliojimas_sudarymas'],
                },
                {
                  key: 'savitarna-ikeitimas-pakeitimas',
                  title:
                    'Pakeisti sandorį informacinių technologijų priemonėmis',
                  tooltip:
                    'Aprašymas. Nauja paslauga. Įkeitimo sudarymas. Pakeitimas',
                  icon: 'mdi-briefcase-edit-outline',
                  col: 12,
                  action: this.redirectToList,
                  igaliotinisRole: ['EL_igaliojimas_sudarymas'],
                },
              ],
            },
          ],
        },
        {
          col: 4,
          colorType: 'hipoteka',
          grupeList: [
            {
              pavadinimas: 'Pranešimas apie įkeitimą',
              tooltip: 'Aprašymas. Nauja paslauga. Įkeitimo pranešimas',
              tootipTop: 10,
              paslaugos: [
                {
                  key: 'sutartinis-ikeitimas-sandoris-teikiamas',
                  title: 'Pranešti apie sudarytą sandorį',
                  tooltip:
                    'Aprašymas. Nauja paslauga. Įkeitimo pranešimas. Teikimas',
                  icon: 'mdi-bank-plus',
                  col: 12,
                  action: this.teikimasNew,
                  igaliotinisRole: ['EL_igaliojimas_teikimas'],
                },
                {
                  key: 'savitarna-ikeitimas-pakeitimas-teikiamas',
                  title: 'Pranešti apie pakeistą sandorį',
                  tooltip:
                    'Aprašymas. Nauja paslauga. Įkeitimo pranešimas. Pakeitimas',
                  icon: 'mdi-bank-transfer',
                  col: 12,
                  action: this.redirectToList,
                  igaliotinisRole: ['EL_igaliojimas_teikimas'],
                },
              ],
            },
          ],
        },
        {
          col: 12,
          colorType: 'sutartis',
          grupeList: [
            {
              pavadinimas: 'Neregistruojamų daiktų sutartis',
              tooltip:
                'Aprašymas. Nauja paslauga. Neregistruojamų daiktų sutartis',
              tootipTop: 10,
              paslaugos: [
                {
                  key: 'savitarna-sutartis-teikimas',
                  title:
                    'Pranešti apie sudarytą neregistruojamų daiktų sutartį',
                  tooltip: 'Aprašymas. Nauja paslauga. Sutartis. Teikimas',
                  icon: 'mdi-file-document-outline',
                  col: 4,
                  action: this.sutartisNew,
                  igaliotinisRole: ['EL_igaliojimas_sutartis'],
                },
                {
                  key: 'savitarna-sutartis-pakeitimas',
                  title: 'Pakeisti neregistruojamų daiktų sutartį',
                  tooltip: 'Aprašymas. Nauja paslauga. Sutartis. Pakeitimas',
                  icon: 'mdi-file-document-multiple-outline',
                  col: 4,
                  action: this.redirectToList,
                  igaliotinisRole: ['EL_igaliojimas_sutartis'],
                },
                {
                  key: 'savitarna-sutartis-pabaiga',
                  title: 'Išregistruoti neregistruojamų daiktų sutartį',
                  tooltip: 'Aprašymas. Nauja paslauga. Sutartis. Pabaiga',
                  icon: 'mdi-file-remove-outline',
                  col: 4,
                  action: this.redirectToList,
                  igaliotinisRole: ['EL_igaliojimas_sutartis'],
                },
                {
                  key: 'savitarna-sutartis-neisregistruoti',
                  title: 'Prašyti neišregistruoti sutarties automatiškai',
                  tooltip:
                    'Aprašymas. Nauja paslauga. Sutartis. Prašymas neišregistruoti',
                  icon: 'mdi-file-edit-outline',
                  col: 4,
                  action: this.redirectToList,
                  igaliotinisRole: ['EL_igaliojimas_sutartis'],
                },
                {
                  key: 'savitarna-sutartis-pageidavimas',
                  title: 'Pageidauti pasinaudoti atpirkimo teise',
                  tooltip: 'Aprašymas. Nauja paslauga. Sutartis. Pageidavimas',
                  icon: 'mdi-file-export-outline',
                  col: 4,
                  action: this.redirectToList,
                  igaliotinisRole: ['EL_igaliojimas_sutartis'],
                },
                {
                  key: 'savitarna-sutartis-atsaukimas',
                  title: 'Atšaukti pageidavimą pasinaudoti atpirkimo teise',
                  tooltip:
                    'Aprašymas. Nauja paslauga. Sutartis. Pageidavimo atšaukimas',
                  icon: 'mdi-file-lock-outline',
                  col: 4,
                  action: this.redirectToList,
                  igaliotinisRole: ['EL_igaliojimas_sutartis'],
                },
              ],
            },
          ],
        },
      ]
    },

    sutartisRusisKey() {
      return `sutartisrusis-${this.sutartisRusisRefresh}`
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = false
    },
    openSutartisRusis() {
      this.loading = true
      this.sutartisRusisRefresh++
      this.showSutartisRusis = true
    },
    confirmSutartisRusis(objektasTipas) {
      this.sukurtiHipoteka(objektasTipas)
      this.loading = false
    },
    sutartisNew() {
      this.loading = true
      this.openSutartisRusis()
    },
    ikeitimasNew(objektasTipas) {
      this.loading = true
      this.confirmTitle = 'Sudaryti sandorį'
      this.confirmText =
        'Ar norite sudaryti įkeitimo sandorį informacinių technologijų priemonėmis, <br>kai <b>įkeitimo objektas perduodamas kreditoriui</b>?'
      this.confirmAction = 'AddIkeitimas'
      this.confirmItem = { objektasTipas: objektasTipas }
      this.showConfirm = true
    },
    addIkeitimas(item) {
      this.sukurtiHipoteka(item.objektasTipas, item.perduodamasKreditoriui)
    },
    teikimasNew(objektasTipas) {
      this.loading = true
      this.confirmTitle = 'Pranešti apie sudarytą sandorį'
      this.confirmText =
        'Ar norite pranešti apie sudarytą įkeitimo sandorį, kai <b>įkeitimo objektas perduodamas kreditoriui</b>?'
      this.confirmAction = 'AddTeikimas'
      this.confirmItem = { objektasTipas: objektasTipas }
      this.showConfirm = true
    },
    addTeikimas(item) {
      this.sukurtiHipoteka(item.objektasTipas, item.perduodamasKreditoriui)
    },
    sukurtiHipoteka(objektasTipas, perduodamasKreditoriui = null) {
      this.loading = true
      this.pageloading = true
      const data = {
        obj_tipas: objektasTipas,
        dok_id: null,
        vyk_id: null,
        obj_kita_perduodamas_kreditoriui: perduodamasKreditoriui,
      }
      this.$axios
        .post(`objektas`, data)
        .then(res => {
          this.$store.dispatch('objektasID', res.data.objektas.obj_id)
          this.$store.dispatch('hipotekaTipas', objektasTipas)
          this.$store.dispatch('objektasVeiksmas', 0)
          this.$router.push({
            name: 'hipotekaPranesimas',
            params: {
              objektasID: res.data.objektas.obj_id,
            },
          })
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.loading = false
          this.pageloading = false
        })
    },
    cancelConfirm() {
      this.loading = false
    },
    redirectToList(tipas) {
      this.loading = true

      const data = {
        veiksmas: tipas,
      }

      this.$axios
        .post(`pranesimas/paslauga-kiekis`, data)
        .then(res => {
          let kiekis = res.data.kiekis

          if (kiekis > 0) {
            this.$router.push({
              name: 'dokumentai',
              params: {
                savitarnaVeiksmasKey: tipas,
              },
            })
          } else {
            this.openInfo(tipas)
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openInfo(tipas) {
      this.infoTitle = 'Veiksmas negalimas'
      this.infoText = HipotekaMap['savitarnaVeiksmas'][tipas].fail ?? ''
      this.infoType = 'error'
      this.showInfo = true
    },
    openIgaliotinisInfo() {
      this.infoTitle = 'Veiksmas negalimas'
      this.infoText = 'Jūs neturite įgaliojimų atlikti šį veiksmą'
      this.infoType = 'error'
      this.showInfo = true
    },
    submitInfo(item) {
      this.showInfo = false
    },
    showAprasymas(tipas, tipasTop) {
      this.paslaugaAprasymas = tipas
      this.paslaugaAprasymasTop = tipasTop
    },
    hideAprasymas() {
      this.paslaugaAprasymas = null
      this.$store.dispatch('activeTooltip', '')
    },
    paslaugaAction(paslauga) {
      if (
        this.role(['EL_igaliotinis']) &&
        !this.roleOr(paslauga.igaliotinisRole)
      ) {
        this.openIgaliotinisInfo()
        return
      }
      paslauga.action(paslauga.key)
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  min-width: 980px;
}
.paslaugaContainer {
  width: 745px;
  float: left;
}
.aprasymasContainer {
  margin-left: 750px;
  max-width: 550px;
}
.paslauga-card {
  height: 100%;
  padding-top: 16px;
}
.paslauga-title {
  font-size: 0.95rem;
  padding-top: 0;
}
.paslauga-icon {
  height: 100%;

  &:hover {
    cursor: pointer;
    background: #e5e5e5;
  }
}
.paslauga-aprasymas {
  position: relative;
}
.paslauga-tooltip {
  font-size: 12px;
}
</style>
